import { Component, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { EventService } from '../../service/event.service';
import { GtmService } from '../../service/gtm.service';
import { UserDataService } from '../../service/userDataService';

@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    imports: [TranslateModule],
})
export class HeaderComponent {
    private userDataService = inject(UserDataService);
    private eventService = inject(EventService);
    private gtm = inject(GtmService);

    isBetmgmLabel: boolean;
    showNewHeader: boolean;
    constructor() {
        this.isBetmgmLabel = this.userDataService.userData.userInfo.labelInfo.brandId.toLowerCase().includes('mgm');
        this.showNewHeader = this.userDataService.userData?.configParams?.isBrazilBankRegEnabled;
    }

    closeCashier() {
        // const appholder = document.getElementById('cashierAppHolder') as any;
        // appholder.style.display = 'none';
        //GTM event to track close click of QD
        this.gtm.raiseEventForQuickDepositClose('click x', 'not applicable', 'exit', 'quick deposit');
        this.eventService.raiseCloseEvent();
    }
}
